var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-absolute xs:tw-top-3 xs:tw-left-3 lg:tw--top-8 lg:tw--left-0 tw-font-medium tw-text-gray-500"},[_vm._v("\n    Schritt "+_vm._s(_vm.step)+" von "+_vm._s(_vm.totalSteps)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }